import axios from 'axios';
import { Recording } from '@hotjar/webapp/features/Playbacks/types';
import { CommentsByRecordingIdDTO, LabelsByRecordingIdDTO } from '../../../domains/highlights';
import { getSiteId } from '../../../utils/getParamsFromUrlPathname';

const API_ROOT_V1 = '/api/v1/sites/';

/**
 * Fetches Highlights content (comments and labels for each of them) for the highlights that are associated
 * with the given recordings.
 *
 * @param recordings The recordings that the highlights should be associated with.
 */
export const fetchHighlightsContentForRecordings = async (
  recordings: Recording[],
): Promise<{
  commentsByRecordingId: CommentsByRecordingIdDTO;
  labelsByRecordingId: LabelsByRecordingIdDTO;
}> => {
  const params = recordings
    .map((recording) => recording.id)
    // if we pass recordingIds as it is to axios, will compute to: ?rec_ids[]=x&rec_ids[]=y...
    // and BE will throw a 400 Bad Request.
    .reduce((acc, curr) => {
      acc.append('rec_ids', curr.toString());

      return acc;
    }, new URLSearchParams());

  const {
    data: { comments: commentsByRecordingId = {}, labels: labelsByRecordingId = {} },
  } = await axios.get(`${API_ROOT_V1}${getSiteId()}/highlights/recordings`, { params });

  return { commentsByRecordingId, labelsByRecordingId };
};
